import {alias, createModelSchema} from "serializr";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";
import {RewardBunch} from "@/modules/redactor/models/reward/RewardBunch";

export class DailyBonusTrack extends BaseObject {

    constructor() {
        super();

        this._key = null;
        this._name = null;
        this._reward = null;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    valid() {

        if (!this.reward || !this.reward.valid()) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new DailyBonusTrack());
        } else if (target instanceof DailyBonusTrack) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(DailyBonusTrack, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _reward: alias("reward", RewardBunch.schema())
});